import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

interface PageContainerProps {
  children: ReactNode;
}

export function PageContainer({ children }: PageContainerProps) {
  return (
    <div className="min-h-screen flex flex-col pt-14 sm:pt-24">
      <Header />
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 py-6">
        {children}
      </main>
      <Footer />
    </div>
  );
}
